import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeatherRrufe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 30.936,
	height: 27.475,
	viewBox: "0 0 30.936 27.475",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_9026",
				"data-name": "Path 9026",
				d: "M272.415,21.819l-3.34,3.341v0l1.428,1.181-1.539,2.78,3.4-2.631-1.428-1.428Z",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: -35.645,
			y1: 2.285,
			x2: -35.511,
			y2: 2.285,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#fab300"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#f6db00"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_9027",
				"data-name": "Path 9027",
				d: "M280.383,21.06l-4.614,4.615v0l1.973,1.633-2.126,3.841,4.7-3.636-1.972-1.973Z",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-2",
			x1: -26.364,
			y1: 1.674,
			x2: -26.267,
			y2: 1.674,
			xlinkHref: "#linear-gradient"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-3",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_9028",
				"data-name": "Path 9028",
				d: "M287.032,21.819l-3.338,3.341v0l1.428,1.181-1.54,2.78,3.4-2.631-1.427-1.428Z",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-3",
			x1: -37.597,
			y1: 2.286,
			x2: -37.463,
			y2: 2.286,
			xlinkHref: "#linear-gradient"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-4",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_9029",
				"data-name": "Path 9029",
				d: "M266.554,13.912a3.051,3.051,0,0,0-.768-.1,2.494,2.494,0,0,0-2.582,2.834c.726,4.1,13.286,3.995,12.84-.716a2.426,2.426,0,0,0-3.524-1.794,3.039,3.039,0,0,0-5.966-.223",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-4",
			x1: -16.314,
			y1: 1.686,
			x2: -16.251,
			y2: 1.686,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#437aff"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#67a4fe"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-5",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_9030",
				"data-name": "Path 9030",
				d: "M274.64,6.582a3.7,3.7,0,0,0-.946-.125,3.752,3.752,0,0,0-3.735,3.386,3.753,3.753,0,0,0-5.589,3.274c0,.12.007.237.018.354a3.426,3.426,0,0,1,1.4-.3c.108,0,.22.005.33.016a3.68,3.68,0,0,1,6.84.1,2.987,2.987,0,0,1,.657-.074,3.039,3.039,0,0,1,3.066,2.654,3,3,0,0,1-.8,2.352,5.045,5.045,0,0,1-1.672,1.154,6.785,6.785,0,0,0,3.929,1.162c2.466,0,4.548-1.13,5.22-2.678a3.748,3.748,0,0,0,5.719-1.586c1.91-.531,3.273-1.907,3.273-3.521a2.871,2.871,0,0,0-.26-1.186,11.556,11.556,0,0,1-4.418.789h0c-3.2,0-6.615-1.077-7.04-3.481a2.906,2.906,0,0,1,.652-2.413A3.127,3.127,0,0,1,281.76,6a3.747,3.747,0,0,0-7.12.585",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-5",
			x1: -8.12,
			y1: 1.271,
			x2: -8.089,
			y2: 1.271,
			xlinkHref: "#linear-gradient-4"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-6",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_9031",
				"data-name": "Path 9031",
				d: "M284.6,6.031a3.052,3.052,0,0,0-.768-.1,2.5,2.5,0,0,0-2.582,2.834c.725,4.105,13.286,4,12.84-.715a2.425,2.425,0,0,0-3.524-1.8,3.039,3.039,0,0,0-5.966-.222",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-6",
			x1: -17.44,
			y1: 2.263,
			x2: -17.377,
			y2: 2.263,
			xlinkHref: "#linear-gradient-4"
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_6246",
		"data-name": "Group 6246",
		transform: "translate(902.833 -1499.558)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_6172",
				"data-name": "Group 6172",
				transform: "translate(-1166 1495.887)",
				clipPath: "url(#clip-path)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_2070",
					"data-name": "Rectangle 2070",
					width: 7.489,
					height: 3.874,
					transform: "translate(268.536 29.093) rotate(-86.633)",
					fill: "url(#linear-gradient)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_6174",
				"data-name": "Group 6174",
				transform: "translate(-1166 1495.887)",
				clipPath: "url(#clip-path-2)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_2071",
					"data-name": "Rectangle 2071",
					width: 10.349,
					height: 5.352,
					transform: "translate(275.024 31.112) rotate(-86.634)",
					fill: "url(#linear-gradient-2)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_6176",
				"data-name": "Group 6176",
				transform: "translate(-1166 1495.887)",
				clipPath: "url(#clip-path-3)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_2072",
					"data-name": "Rectangle 2072",
					width: 7.489,
					height: 3.873,
					transform: "matrix(0.059, -0.998, 0.998, 0.059, 283.154, 29.093)",
					fill: "url(#linear-gradient-3)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_6178",
				"data-name": "Group 6178",
				transform: "translate(-1166 1495.887)",
				clipPath: "url(#clip-path-4)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_2073",
					"data-name": "Rectangle 2073",
					width: 16.041,
					height: 13.676,
					transform: "translate(259.688 12.893) rotate(-22.443)",
					fill: "url(#linear-gradient-4)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_6180",
				"data-name": "Group 6180",
				transform: "translate(-1166 1495.887)",
				clipPath: "url(#clip-path-5)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_2074",
					"data-name": "Rectangle 2074",
					width: 32.293,
					height: 26.268,
					transform: "translate(258.419 6.13) rotate(-22.443)",
					fill: "url(#linear-gradient-5)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_6182",
				"data-name": "Group 6182",
				transform: "translate(-1166 1495.887)",
				clipPath: "url(#clip-path-6)",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_2075",
					"data-name": "Rectangle 2075",
					width: 16.04,
					height: 13.676,
					transform: "translate(277.737 5.012) rotate(-22.443)",
					fill: "url(#linear-gradient-6)"
				})
			})
		]
	})]
});
export { SvgWeatherRrufe as ReactComponent };
